import Typography from '@hellodarwin/core/lib/components/common/typography';
import styled, { css } from 'styled-components';
export const TaskTableContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;
export const TaskTableFilterBar = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md}px;
  flex-wrap: wrap;
`;
export const TaskTableFilterDivider = styled.span `
  width: 1px;
  align-self: stretch;
  min-height: ${({ theme }) => theme.spacing.xl}px;
  margin: 0 ${({ theme }) => theme.spacing.md}px;
  background: ${({ theme }) => theme.colors.grey_4};
`;
export const TaskTableToggleGroup = styled.div `
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}px;
  padding: ${({ theme }) => theme.spacing.xs}px;
  min-height: ${({ theme }) => theme.spacing.lg + theme.spacing.xs + theme.spacing.xs}px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.purple_2};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  background: ${({ theme }) => theme.colors.purple_2};
`;
export const TaskTableToggleButton = styled.button `
  border: none;
  border-radius: ${({ theme }) => theme.border_radius.sm};
  padding: ${({ theme }) => `${theme.spacing.xs + theme.spacing.xs / 2}px ${theme.spacing.base + theme.spacing.xs}px`};
  background: ${({ $active, theme }) => $active ? theme.colors.white_1 : theme.colors.purple_2};
  color: ${({ $active, theme }) => $active ? theme.colors.grey_1 : theme.colors.white_1};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: ${({ theme }) => theme.fonts.body4};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  transition:
    background 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: ${({ $active, theme }) => $active ? theme.colors.white_1 : theme.colors.purple_1};
    color: ${({ $active, theme }) => $active ? theme.colors.grey_1 : theme.colors.white_1};
  }

  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.colors.grey_1};
    outline-offset: -1px;
  }
`;
export const TaskTableTitleButton = styled.button `
  display: block;
  width: 100%;
  min-width: 0;
  padding: 0;
  border: 0;
  background: ${({ theme }) => theme.colors.transparent};
  color: ${({ theme }) => theme.colors.grey_1};
  cursor: pointer;
  font: inherit;
  text-align: left;

  &:hover,
  &:focus-visible {
    color: ${({ theme }) => theme.colors.purple_1};
    text-decoration: underline;
    text-decoration-thickness: from-font;
    text-underline-offset: ${({ theme }) => theme.spacing.xs}px;
  }
`;
export const TaskTableTitleText = styled(Typography).attrs({
    elementTheme: 'body2',
    className: 'sorted-table-task-title',
}) `
  display: -webkit-box;
  overflow: hidden;
  color: inherit;
  overflow-wrap: anywhere;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;
export const TaskTableCellText = styled(Typography).attrs({
    elementTheme: 'body2',
}) `
  color: ${({ theme }) => theme.colors.grey_1};
`;
export const TaskTableMutedText = styled(Typography).attrs({
    elementTheme: 'body2',
}) `
  color: ${({ theme }) => theme.colors.grey_3};
`;
export const TaskTableCenteredCell = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  white-space: nowrap;
`;
export const TaskTableOwnerPillsContainer = styled.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.xs}px;
  min-width: 0;
  max-width: 100%;
  overflow: visible;
`;
export const TaskTableOwnerPill = styled.span `
  appearance: none;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  max-width: 100%;
  min-width: 0;
  padding: ${({ theme }) => `${theme.spacing.xs}px ${theme.spacing.base + theme.spacing.xs / 2}px`};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  border-radius: ${({ theme }) => theme.border_radius.full};
  background: ${({ theme }) => theme.colors.beige_3};
  color: ${({ theme }) => theme.colors.grey_1};
  cursor: ${({ $interactive }) => ($interactive ? 'pointer' : 'inherit')};
  font-family: inherit;
  font-size: ${({ theme }) => theme.fonts.body4};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const TaskTableOverflowTooltipList = styled.ul `
  display: flex;
  flex-direction: column;
  margin: 0;
  padding-inline-start: ${({ theme }) => theme.spacing.lg}px;
`;
export const TaskTableStatusPill = styled.span `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: ${({ theme }) => theme.spacing.xxl + theme.spacing.lg}px;
  height: ${({ theme }) => theme.spacing.xl}px;
  padding: 0 ${({ theme }) => theme.spacing.base + theme.spacing.xs}px;
  border-radius: ${({ theme }) => theme.border_radius.sm};
  font-size: ${({ theme }) => theme.fonts.body4};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  text-transform: uppercase;
  white-space: nowrap;

  ${({ $tone, theme }) => {
    switch ($tone) {
        case 'danger':
            return css `
          background: ${theme.colors.red_1};
          color: ${theme.colors.white_1};
        `;
        case 'warning':
            return css `
          background: ${theme.colors.yellow_2};
          color: ${theme.colors.grey_1};
        `;
        case 'success':
            return css `
          background: ${theme.colors.green_2};
          color: ${theme.colors.grey_1};
        `;
        default:
            return css `
          background: ${theme.colors.grey_5};
          color: ${theme.colors.grey_2};
        `;
    }
}}
`;
